/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * Use `INDIVIDUAL` `LEGAL` `UNDEFINED`.
 * 
 * `PRIVATE` and `BUSINESS` are deprecated.
 * 
 * @export
 * @enum {string}
 */
export enum ApiPersonType {
    INDIVIDUAL = 'INDIVIDUAL',
    PRIVATE = 'PRIVATE',
    BUSINESS = 'BUSINESS',
    LEGAL = 'LEGAL',
    UNDEFINED = 'UNDEFINED'
}


export function instanceOfApiPersonType(value: any): boolean {
    for (const key in ApiPersonType) {
        if (Object.prototype.hasOwnProperty.call(ApiPersonType, key)) {
            if (ApiPersonType[key as keyof typeof ApiPersonType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiPersonTypeFromJSON(json: any): ApiPersonType {
    return ApiPersonTypeFromJSONTyped(json, false);
}

export function ApiPersonTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPersonType {
    return json as ApiPersonType;
}

export function ApiPersonTypeToJSON(value?: ApiPersonType | null): any {
    return value as any;
}

export function ApiPersonTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiPersonType {
    return value as ApiPersonType;
}

